<div class="day-row" *ngFor="let dayCell of grid.dayCellData">
  <div *ngFor="let hourForDate of hoursForDate; index as hourIndex">
    <button mat-fab class="hour-to-navigate-to" (click)="onHourClicked(hourForDate)" [class.selected-hour]="isHourSelected(hourForDate)">
      {{ hourForDate.start | date: 'HH' }}
    </button>
  </div>
</div>
<vdw-regimes-indicator></vdw-regimes-indicator>
